



























































import { Button, MDInput } from "@micad/vue-components";
import { defineComponent, reactive } from "@vue/composition-api";
import router from "@/router";
import { displayRequestStatus } from "@/notifications";
import Loading from "@/components/Loading.vue";
import { getKV } from "@/modules/browserLocalStorage";
import { updateHistoricalAccount } from "@/data/repos/historicAccounts";

const CLIENT_COOKIE_NAME = "X-Authorization-ClientId";

export default defineComponent({
  components: {
    Loading,
    MDInput,
    Button,
  },
  props: {},
  setup() {
    const state = reactive({
      type: router.currentRoute.query.type,
      showStage: "",
      clientKeyHint: getKV(CLIENT_COOKIE_NAME),
      email: "",
      errorMessage: "",
      loaded: true,
      onSubmit,
    });

    if (state.type && state.type === "legacy") {
      state.showStage = "emailUpdate";
    } else if (state.type && state.type === "legacyEmail") {
      state.showStage = "accountWarning";
    }

    async function onSubmit(email: string) {
      state.errorMessage = "";
      state.loaded = false;
      const response = await updateHistoricalAccount({ email });
      displayRequestStatus(response, "");
      if (response.ok) {
        state.loaded = true;
        state.showStage = "accountWarning";
      } else {
        state.errorMessage =
          response.response?.data?.errorMessage || "An error has occurred...";
        state.loaded = true;
      }
    }
    return state;
  },
});
